export default "__VITE_ASSET__Br1sc4JW__"